import { autoRegisterFeature } from '@store/features/factory';

import { jotSupportFeature } from './store/feature';

autoRegisterFeature(jotSupportFeature);

export * from './components';
export { JotSupportContainer } from './components/JotSupportContainer';
export { JotSupportWithPulse } from './pulse/JotSupportWithPulse';
export * from './store';
export type { SupportDraft, SupportInteraction, SupportView } from './types';
